import { ElasticCourseData } from '@spikemark/rest-api';
import keyBy from 'lodash/keyBy';

export const createCourseInfoMap = (courses?: ElasticCourseData[]) => {
  return keyBy(courses, (course) => [course.roundId, course.courseLabel].join('-'));
};

export const getLeaderboardRankingDisplay = (
  rankings: (number | undefined)[],
  currentRank?: number
): string | number => {
  if (!currentRank) {
    return '';
  }

  const frequency = getRankingFrequency(rankings, currentRank);

  return frequency > 1 ? `T${currentRank}` : currentRank;
};

const getRankingFrequency = (rankings: (number | undefined)[], currentRank: number): number => {
  let frequency = 0;

  for (const rank of rankings) {
    if (rank === currentRank) {
      frequency += 1;
    }
  }

  return frequency;
};

export const scoreFormat = (score: number) => {
  if (score === 0) {
    return 'E';
  } else if (score === -1000) {
    return `-`;
  } else if (score > 9000) {
    return 'N/A';
  } else if (score > 0) {
    return `+${score}`;
  } else {
    return score;
  }
};
